import React, { useState } from "react";
import "./style.scss";
import NoticeIndex from "./../NoticeIndex";
import NoPermission from "./../NoPermission";
import { queryDownJosSdkInfo } from "utils/api";

export default function AppPermission(props) {
  const [empty, setEmpty] = useState(false);
  const [optionshow, setShowOption] = useState(false);
  const { appKey } = props;

  window.onclick = (e) => {
    if (e.target.id !== "sdk_select") {
      setShowOption(false);
    }
  };
  const handleDownload = () => {
    return setShowOption(!optionshow);
  };

  const handleDownloadDetail = (langType) => {
    queryDownJosSdkInfo({
      appKey: appKey,
      packRangeType: 1,
      langType: langType,
    }).then((res) => {
      if (res.data.success && res.data.result.sdkPackInfoList.length !== 0) {
        const triggerDelay = 100;
        const removeDelay = 1000;
        res.data.result.sdkPackInfoList.map((item, index) => {
          createIFrame(item.fileDownUrl, index * triggerDelay, removeDelay);
          return res.data.result;
        });
      }
      return setShowOption(false);
    });
  };

  // 这里是创建iframe的方法
  const createIFrame = (url, triggerDelay, removeDelay) => {
    //动态添加iframe，设置src，然后删除
    setTimeout(function () {
      var frame = document.createElement("iframe");
      frame.src = url;
      frame.style.display = "none";
      document.body.appendChild(frame);
      setTimeout(function () {
        frame.remove();
      }, removeDelay);
    }, triggerDelay);
  };

  const onHandleTableData = (res) => {
    if (!(res && res.length)) {
      setEmpty(true);
    }
  };

  return (
    <div className="app_permission">
      <div className="permission_title">应用权限</div>
      {empty ? (
        <NoPermission content="应用未绑定合同，无法查看应用权限" isshow="true"/>
      ) : (
        <div className="has_permission">
          <div className="sdk_download">
            <div
              id="sdk_select"
              className={`sdk_select ${optionshow ? "select_cur" : ""}`}
              onClick={handleDownload}
            >
              打包SDK下载
              <div className="arrow"></div>
            </div>
            {optionshow ? (
              <ul className="sdk_option">
                {/* <li className="disabled">
                    Java SDK 下载
                  </li > */}
                <li className="downloaad">
                  Java SDK
                  <i
                    className="icon_download"
                    onClick={handleDownloadDetail.bind(this, 3) }
                    clstag="pageclick|keycount|VopOpenConsole_1611892618710|5"
                  ></i>
                </li>
                <li className="downloaad">
                  Net SDK
                  <i
                    className="icon_download"
                    onClick={handleDownloadDetail.bind(this, 2)}
                    clstag="pageclick|keycount|VopOpenConsole_1611892618710|6"
                  ></i>
                </li>
                <li className="downloaad">
                  PHP SDK
                  <i
                    className="icon_download"
                    onClick={handleDownloadDetail.bind(this, 1)}
                    clstag="pageclick|keycount|VopOpenConsole_1611892618710|7"
                  ></i>
                </li>
                <li className="downloaad">
                  Python SDK
                  <i
                    className="icon_download"
                    onClick={handleDownloadDetail.bind(this, 4)}
                    clstag="pageclick|keycount|VopOpenConsole_1611892618710|8"
                  ></i>
                </li>
              </ul>
            ) : (
              ""
            )}
          </div>
          <NoticeIndex appKey={appKey} onHandleTableData={onHandleTableData} />
        </div>
      )}
    </div>
  );
}
